var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_content"},[_vm._v(" "+_vm._s(_vm.$t('other.version_footer', {v: _vm.getVersion}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }